<template>
    <div class="contant-warpper">
      <!--<navTab></navTab>-->
      <catchContent></catchContent>
    </div>
</template>

<script>
  import contentWarpJs from './contentWarp.js'
  export default contentWarpJs

</script>

<style lang="scss" scoped>
  @import "contentWarp";
</style>



// WEBPACK FOOTER //
// src/layout/contentWarp/contentWarp.vue